/**
 * Stripe-Connect Fixture.
 * Quelle: 01_apis/01_core.api.valitype.net/ADMIN/views.md → #/stripe-connect
 */

function persist() {
  if (typeof window === 'undefined') return null;
  if (!window.__ORBIT_STRIPE_CONNECT_DB__) {
    window.__ORBIT_STRIPE_CONNECT_DB__ = {
      accountId: null,
      chargesEnabled: false,
      payoutsEnabled: false,
      detailsSubmitted: false,
      requirementsCurrentlyDue: [],
      pendingVerification: [],
      applicationFeeBps: 100,
      country: 'DE',
      defaultCurrency: 'EUR',
      onboardingExpiresAt: null,
    };
  }
  return window.__ORBIT_STRIPE_CONNECT_DB__;
}

export function stripeConnectFixture() {
  const db = persist();
  return { ...db };
}

export function createConnectedAccountFixture() {
  const db = persist();
  db.accountId = `acct_${Math.random().toString(36).slice(2, 18)}`;
  db.requirementsCurrentlyDue = ['individual.first_name', 'individual.last_name', 'individual.dob', 'individual.address', 'tos_acceptance.date'];
  db.onboardingExpiresAt = new Date(Date.now() + 24 * 3_600_000).toISOString();
  return {
    accountId: db.accountId,
    onboardingUrl: `https://connect.stripe.com/setup/s/sample-${db.accountId}`,
    expiresAt: db.onboardingExpiresAt,
  };
}

export function refreshStripeConnectFixture() {
  const db = persist();
  if (!db.accountId) return { ...db };
  // Simuliere KYC-Progress
  if (db.requirementsCurrentlyDue.length > 0) {
    db.requirementsCurrentlyDue = db.requirementsCurrentlyDue.slice(2);
  }
  if (db.requirementsCurrentlyDue.length === 0) {
    db.detailsSubmitted = true;
    db.chargesEnabled = true;
    db.payoutsEnabled = true;
  }
  return { ...db };
}

export function dashboardLinkFixture() {
  return {
    url: `https://dashboard.stripe.com/express/loginlink/sample`,
    expiresAt: new Date(Date.now() + 5 * 60_000).toISOString(),
  };
}

export function updateStripeConnectFixture(patch) {
  const db = persist();
  Object.assign(db, patch);
  return { ...db };
}
